import { Component } from '@angular/core';
import { BaseAthleteAnswer } from '../base-athlete-answer';
import { FeedbackQuestion } from "../../../common/models/feedback-question";
import { NgForOf } from "@angular/common";
import { MatLine } from "@angular/material/core";

@Component({
  selector: 'app-feedback-remark-athlete-answer',
  templateUrl: 'feedback-remark-athlete-answer.component.html',
  standalone: true,
  imports: [
    NgForOf,
    MatLine
  ],
  styleUrls: ['../athlete-answers.css']
})
export class FeedbackRemarkAthleteAnswerComponent extends BaseAthleteAnswer {
    public static type = FeedbackQuestion.TYPE_REMARK;
}
